/**
 * Returns a callback to initialize the slick behavior.
 * @param {Element} component
 * @param {Number} unloadWidth
 * @return {Function} A callback function
 */

const handleUnloadableInit = (component, unloadWidth = 586) => () => {
    if ($(window).width() > unloadWidth) {
        if ($(component).hasClass('slick-initialized')) {
            $(component).slick('unslick');
        }
    } else if (!$(component).hasClass('slick-initialized')) {
        $(component)
            .slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                focusOnSelect: false,
                dots: false,
                arrows: false,
                infinite: false,
                variableWidth: true,
                mobileFirst: true,
                swipeToSlide: true,
                rows: 0,
                draggable: true,
                edgeFriction: 0.03,
                touchMove: true,
                touchThreshold: 180,
            });
    }
};

export default handleUnloadableInit;



// WEBPACK FOOTER //
// ./src/scripts/components/item-slider/handleUnloadableInit.js